import React, { createContext, useState } from "react";

import { noop } from "@catchoftheday/utilities";

type ContextData = {
  deletedWishlistProductId: string | null;
  setDeletedWishlistProductId: React.Dispatch<
    React.SetStateAction<string | null>
  >;
};

export const WishlistContext = createContext<ContextData>({
  deletedWishlistProductId: null,
  setDeletedWishlistProductId: noop,
});

export const WishlistContextProvider: React.FC = ({ children }) => {
  const [deletedWishlistProductId, setDeletedWishlistProductId] =
    useState(null);

  return (
    <WishlistContext.Provider
      value={{
        deletedWishlistProductId,
        setDeletedWishlistProductId,
      }}
    >
      {children}
    </WishlistContext.Provider>
  );
};
